module.exports = __webpack_public_path__ + "img/deco-14.7c6e01c7.png";